/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PopUpModal from "../../PopUpModal/PopUpModal";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import {
  MPS_EVENT_REGISTRATION_STEPPER_STEP_TITLES,
} from "../../../constants/stepperStepsTitles";
import ModalLoadingState from "../../PopUpModal/ModalLoadingState";
import MPSEventRegistration1 from "./MPSEventRegistration1";
import MPSEventRegistration2 from "./MPSEventRegistration2";
import ModalMPSEventRegistrationSuccess from "./ModalMPSEventRegistrationSuccess";
import ModalMPSEventRegistrationFailure from "./ModalMPSEventRegistrationFailure";
import ModalMPSSaveChangesSuccess from "./ModalMPSSaveChangesSuccess";
import ModalMPSSaveChangesFailure from "./ModalMPSSaveChangesFailure";
import { useMPSEventRegistration } from "../../../context/MPSEventRegistrationContext";
import { getEventDetails } from "../../../firebaseFunctions/getEventDetails/getEventDetails.js";
import { submitMPSApplication } from "../../../firebaseFunctions/submitMPSApplication/submitMPSApplication.js";

const MPSEventRegistration = () => {
  const { user } = useAuth();
  const MPSProfileID = user.uid;
  const eventId = useParams();
  const navigate = useNavigate();
  const steps = MPS_EVENT_REGISTRATION_STEPPER_STEP_TITLES;
  const [activeStep, setActiveStep] = React.useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpModalType, setPopUpModalType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    updateMPSEventRegistration,
    getMPSEventRegistrationBusinessInfo,
  } = useMPSEventRegistration();
  const [mpsEventRegistrationInfo, setMPSEventRegistrationInfo] = useState([])
  const [eventDetails, setEventDetails] = useState(null);

  useEffect(() => {
    if (eventId.id && MPSProfileID) {

      const fetchPreFilledData = async () => {
        setIsLoading(true);
        try {
          // Fetch the MPS event registration data
          const mpsDetails = await getMPSEventRegistrationBusinessInfo(MPSProfileID);
          if (mpsDetails.success) {
            const data = mpsDetails.data
            const response = await updateMPSEventRegistration(data)
            setMPSEventRegistrationInfo(response);
          }
        } catch (error) {
          console.log("Error fetching MPS profile data:", error);
        }

        try {
          // Fetch event details using getEventDetails function
          const eventDetailsData = await getEventDetails(eventId.id);
          if (eventDetailsData.success) {
            setEventDetails(eventDetailsData.data);
          }
        } catch (error) {
          console.error("Error fetching event details:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchPreFilledData();
    }
  }, [eventId.id, MPSProfileID]);




  const handleOpen = () => {
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
  };

  //   // Object containing the step labels
  const handleNext = () => {
    setActiveStep((cur) => cur + 1);
  };

  const handleContinue = () => {
    handleNext();
  };

  const handlePrevious_step = () => {
    setActiveStep((cur) => cur - 1);
  };
  const handlePrevious = () => {
    handlePrevious_step();
  };

  const handleCancel = () => {
    navigate("/mps/view-event-details/" + eventId.id);
  };

  const handleSave = (updatedInfo) => {
    setMPSEventRegistrationInfo(updatedInfo)
    setIsLoading(true);
    handleOpen(true);
    const response = true;

    if (response === true) {
      setPopUpModalType("saveChangesSuccess");
    } else {
      setPopUpModalType("saveChangesFailure");
    }
    setIsLoading(false);
  };
  const handleEventRegistration = async (registrationData) => {
    const response = await submitMPSApplication({ ...registrationData, userId: MPSProfileID }, eventId);
    setIsLoading(true);
    handleOpen(true);

    if (response.success) {
      setPopUpModalType("eventRegistrationSuccess");
      setIsLoading(false);
    } else {
      setPopUpModalType("eventRegistrationFailure");
      setIsLoading(false);
    }
  };

  const handleGoToDashboard = () => {
    // Navigate directly to Applied tab so the user immediately sees their application
    navigate("/mps/events", { state: { refresh: true, initialTab: "Applied" } });
  };

  const renderCreateEventModal = () => {
    switch (popUpModalType) {
      case "eventRegistrationSuccess":
        return (
          <ModalMPSEventRegistrationSuccess
            handleClose={handleClose}
            handleGoToDashboard={handleGoToDashboard}
            eventName={eventDetails?.event?.eventName}
          />
        );
      case "eventRegistrationFailure":
        return <ModalMPSEventRegistrationFailure handleClose={handleClose} />;
      case "saveChangesSuccess":
        return (
          <>
            <ModalMPSSaveChangesSuccess
              setIsLoading={setIsLoading}
              handleClose={handleClose}
              handleContinue={handleContinue}
              mpsEventRegistrationInfo={mpsEventRegistrationInfo}
              mpsUserId={MPSProfileID}
            />
          </>
        );
      case "saveChangesFailure":
        return (
          <>
            <ModalMPSSaveChangesFailure handleClose={handleClose} />
          </>
        );
      default:
        return <ModalLoadingState />;
    }
  };
  return (
    <>
      <PopUpModal
        open={isModalOpen}
        handleClose={handleClose}
        popUpModalType={popUpModalType}
      >
        {!isLoading ? renderCreateEventModal() : <ModalLoadingState />}
      </PopUpModal>
      <div className="w-full p-6 mx-auto">
        {/* Header */}
        <div className="mb-6 pb-4 border-b border-grey-200">
          <p className="text-xs font-medium text-grey-500 uppercase tracking-wide mb-1">Event Registration</p>
          <h2 className="text-xl font-semibold text-grey-900">{eventDetails?.eventName || "Event Registration"}</h2>
        </div>

        <div className="flex flex-col w-full">
          {/* Progress indicator */}
          <div className="mb-6 px-1">
            <div className="flex items-center gap-1.5 mb-2">
              {steps.map((_, index) => (
                <div
                  key={index}
                  className={`h-1 flex-1 rounded-full transition-all duration-300 ${
                    index + 1 < activeStep
                      ? "bg-grey-900"
                      : index + 1 === activeStep
                      ? "bg-grey-900"
                      : "bg-grey-200"
                  }`}
                />
              ))}
            </div>
            <p className="text-xs text-grey-500">
              Step {activeStep} of {steps.length}
              <span className="mx-1.5 text-grey-300">·</span>
              <span className="text-grey-700 font-medium">{steps[activeStep - 1]?.label}</span>
            </p>
          </div>
          {/* ActiveStepper Components */}
          <div className="w-full">
            {activeStep === 1 && !isLoading && mpsEventRegistrationInfo && (
              <MPSEventRegistration1
                handleContinue={handleContinue}
                handleCancel={handleCancel}
                handleSave={handleSave}
                mpsEventRegistrationInfo={mpsEventRegistrationInfo}
                setMPSEventRegistrationInfo={setMPSEventRegistrationInfo}
              />
            )}
            {activeStep === 2 && (
              <MPSEventRegistration2
                handleCancel={handleCancel}
                handlePrevious={handlePrevious}
                handleEventRegistration={handleEventRegistration}
                eventDetails={eventDetails?.event}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
  // return(<>hello</>);
};

export default MPSEventRegistration;
